import { Chart as ElementChart } from 'react-chartjs-2';
import Chart, { ChartData } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

interface Props {
    optionsColumnDry: LabelElement[];
    optionsColumnRain: LabelElement[];
    optionsLine: LabelElement[];
}

interface LabelElement {
    label: string[] | string;
    value: number;
}

export default function CattleMapGraph({ optionsColumnDry, optionsColumnRain, optionsLine }: Props) {

    Chart.register(ChartDataLabels);

    const charData: ChartData = {
        labels: optionsColumnDry ? optionsColumnDry.map((el) => el.label) : [],
        datasets: [
            {
                type: 'bar',
                backgroundColor: "#D9B43C",
                data: optionsColumnDry ? optionsColumnDry.map((el) => Number((typeof (el.value) == "number" ? el.value : 0).toFixed(2))) : [],
                borderWidth: 1,
                yAxisID: 'y1',
                order: 1
            },
            {
                type: 'bar',
                backgroundColor: "#62B8AE",
                data: optionsColumnRain ? optionsColumnRain.map((el) => Number((typeof (el.value) == "number" ? el.value : 0).toFixed(2))) : [],
                borderWidth: 1,
                yAxisID: 'y2',
                order: 1
            },
            {
                type: 'line',
                backgroundColor: "#324440",
                borderColor: "#324440",
                data: optionsLine ? optionsLine.map((el) => Number((typeof (el.value) == "number" ? el.value : 0).toFixed(2))) : [],
                borderWidth: 2,
                yAxisID: 'y3',
                order: 0
            }
        ],
    };

    return (
        <div>
            <div>
                {optionsColumnDry && optionsColumnDry.every((el: any) => el?.value === 0) && optionsLine.every((el: any) => el?.value === 0) ?
                    <div className='noData'>
                        <span>Sem dados</span>
                    </div>
                    :
                    <div style={{
                        display: 'flex',
                    }}>
                        <div>
                            <div
                                style={{
                                    width: 149,
                                    height: "100%",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    gap: 30
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        gap: 10
                                    }}
                                >
                                    <div className="chart-legend__item">
                                        <div className="chart-legend__icon" style={{
                                            backgroundColor: "#D9B43C",
                                            width: 50,
                                            height: 30,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}>
                                            Seca
                                        </div>
                                    </div>

                                    <div className="chart-legend__item">
                                        <div className="chart-legend__icon" style={{
                                            backgroundColor: "#62B8AE",
                                            width: 50,
                                            height: 30,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}>
                                            Chuva
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 10
                                    }}
                                >
                                    <span>Taxa de lotação</span>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                        <div className="chart-legend__icon" style={{
                                            backgroundColor: "#324440",
                                            width: 10,
                                            height: 10,
                                            borderRadius: "100%"
                                        }} />
                                        <div className="chart-legend__icon" style={{
                                            backgroundColor: "#324440",
                                            width: 32,
                                            height: 2,
                                        }} />
                                        <div className="chart-legend__icon" style={{
                                            backgroundColor: "#324440",
                                            width: 10,
                                            height: 10,
                                            borderRadius: "100%"
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ElementChart
                            id="chart"
                            type='bar'
                            data={charData}
                            height={300}
                            width={972}
                            options={{
                                responsive: false,
                                devicePixelRatio: 4,
                                animation: {
                                    duration: 0
                                },
                                plugins: {
                                    legend: {
                                        display: false,
                                        labels: {
                                            boxWidth: 10,
                                        },
                                    },
                                    datalabels: {
                                        display: false,
                                    },
                                },
                                layout: {
                                    padding: {
                                        top: 10,
                                    }
                                },
                                scales: {
                                    x: {
                                        display: true,
                                        stacked: true,
                                        grid: {
                                            display: true,
                                        },
                                        title: {
                                            display: true,
                                            text: "Nº médio de Animais",
                                            font: {
                                                size: 12,
                                            },
                                        }
                                    },
                                    y1: {
                                        display: false,
                                        position: 'right',
                                    },
                                    y2: {
                                        display: false,
                                    },
                                    y3: {
                                        display: false,
                                    }
                                },
                            }}
                        />
                    </div>
                }
            </div>
        </div>
    )
};